/*
 * Jira Ticket:
 * Created Date: Fri, 21st Feb 2020, 15:45:11 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Register, ForgotPassword } from 'resources/auth';
import ConfigurationPage from 'resources/Configuration/edit';

export default [
  <Route
    exact
    path="/register"
    render={props => <Register {...props} />}
    noLayout
  />,
  <Route
    exact
    path="/forgotPassword"
    render={props => <ForgotPassword {...props} />}
    noLayout
  />,
  // <Route exact path="/Project" render={() => <Redirect to="/" />} />,
  // <Route exact path="/Site" render={() => <Redirect to="/" />} />,
  // <Route exact path="/Subcontract" render={() => <Redirect to="/" />} />,
  // <Route exact path="/Tower" render={() => <Redirect to="/" />} />,
  <Route exact path="/" render={() => <Redirect to="/Inspection" />} />,
  <Route exact path="/Locale" render={() => <Redirect to="/" />} />,
  <Route exact path="/OrganisationSearch" render={() => <Redirect to="/" />} />,
  <Route exact path="/Country" render={() => <Redirect to="/" />} />,
  <Route exact path="/Employment" render={() => <Redirect to="/" />} />,
];
